import React from 'react'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import '../modules/services/realTime/taskOrderList';

export const ExportCSV = ({ csvData, fileName }) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        // ws['H2'].s = {fill: {fgColor: {rgb: "ff6600"}}};
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return (

        <button className="btn btn-default btnExport" onClick={(e) => exportToCSV(csvData, fileName)}>Exportar</button>
    )
}